import { CashReceiptEnums } from "src/app/enum/cash-receipt-enums";
import { IncomeConceptModel } from "./income-concept.model";
import { CurrencyExchangeModel } from "../archive/currency-exchage.model";

export class CashReceiptModel {
  cashReceiptId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  isChargeAccount: boolean = false;
  consecutive: number = 0; // Se llena en el backend
  alterNumber: number | null = null;
  dateCashReceipt: Date = new Date;
  rentalPeriodId: number = 0; // Se llena en el backend
  clientId: number = 0;
  incomeConceptId: number = 0;
  incomeConcept: IncomeConceptModel = new IncomeConceptModel();
  cashReceiptStateId: number = CashReceiptEnums.abierto;
  description: string | null = null;
  observation: string | null = null;
  totalValue: number = 0;
  otherValues: number = 0;
  appliedValue: number = 0;
  refundValue: number = 0;
  utilizationValue: number = 0;
  interestValue: number = 0;
  accountingInterfaceId: number | null = null;
  currencyExchangeId: number | null = null;
  currencyExchange: CurrencyExchangeModel | null = null;
  datePayment: string | null = null;
  commissionValue: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}